module.exports = __webpack_public_path__ + "static/media/information.c8702c56.svg";